import React from 'react';
import { Button } from '../ui/button';
import { cn } from '../../lib/utils';

/**
 * PrimaryButton - Primární CTA tlačítko (žluté)
 * Použití: Hlavní akce, CTA v hero sekcích
 * 
 * @param {React.ReactNode} children - Obsah tlačítka
 * @param {string} className - Dodatečné CSS třídy
 * @param {'sm'|'md'|'lg'} size - Velikost tlačítka
 * @param {Object} props - Ostatní props (onClick, disabled, atd.)
 */
export const PrimaryButton = ({ 
  children, 
  className, 
  size = 'lg',
  ...props 
}) => {
  return (
    <Button
      className={cn(
        'bg-brand-accent hover:bg-brand-accentDark text-brand-dark',
        'btn-rounded font-semibold',
        'transition-all duration-200 ease-in-out',
        'shadow-md hover:shadow-lg hover:shadow-gray-400/50',
        'focus:outline-none focus:ring-2 focus:ring-brand-accent focus:ring-offset-2',
        size === 'lg' && 'px-6 py-4 md:px-8 md:py-6 text-[18px]',
        size === 'md' && 'px-6 py-3 text-[18px]',
        size === 'sm' && 'px-4 py-2 text-[18px]',
        className
      )}
      {...props}
    >
      {children}
    </Button>
  );
};

